<script setup lang="ts">

import { FilterDateRange } from '@shared/ui/filters'
import { AppInput } from '@shared/ui/inputs'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useFiltersChangelog } from '../model/filters-changelog.hook'

defineOptions({
  name: 'FiltersChangelog',
})

const {
  refSearch,
  refDateRange,
  isLoading,
  handleSearch,
  handleClear,
} = useFiltersChangelog()
</script>

<template>
  <div class="box-filters-changelog">
    <div class="box-filters-changelog__fields">
      <AppInput
        v-model="refSearch"
        label="Search"
        placeholder="Action or context"
      />

      <FilterDateRange
        v-model="refDateRange"
        label="Date"
      />
    </div>

    <div class="box-filters-changelog__controls">
      <BtnPrimary
        text="Search"
        element-width="auto"
        :disabled="isLoading"
        @click="handleSearch"
      />
      <BtnSecondary
        text="Clear"
        element-width="auto"
        :disabled="isLoading"
        @click="handleClear"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./FiltersChangelog.scss" />
